module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("profile")))])]), _vm._v(" "), _c('md-card-content', [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.avatar
    }
  })]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.image")))]), _vm._v(" "), _c('md-file', {
    attrs: {
      "id": "fileInput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.profile.name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "name", $$v)
      },
      expression: "profile.name"
    }
  })], 1), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.healthcareId")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.profile.doctorData.healthcareId),
      callback: function($$v) {
        _vm.$set(_vm.profile.doctorData, "healthcareId", $$v)
      },
      expression: "profile.doctorData.healthcareId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "description"
  }), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.$t("admin.descinfo")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.profile.doctorData) ? _c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.discipline")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.profile.doctorData.speciality),
      callback: function($$v) {
        _vm.$set(_vm.profile.doctorData, "speciality", $$v)
      },
      expression: "profile.doctorData.speciality"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("attributes")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.profile.doctorData.specification),
      callback: function($$v) {
        _vm.$set(_vm.profile.doctorData, "specification", $$v)
      },
      expression: "profile.doctorData.specification"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.profile.doctorData) ? _c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.facebook_link")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.profile.doctorData.facebookPageUrl),
      callback: function($$v) {
        _vm.$set(_vm.profile.doctorData, "facebookPageUrl", $$v)
      },
      expression: "profile.doctorData.facebookPageUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.website")))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.profile.doctorData.website),
      callback: function($$v) {
        _vm.$set(_vm.profile.doctorData, "website", $$v)
      },
      expression: "profile.doctorData.website"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("Publikus Facebook oldal megadásával a páciensek a Pulmoment alkalmazásán keresztül is olvashatják a Facebookon megosztott híreit.")]), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("introduction")))]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.profile.doctorData.introduction),
      callback: function($$v) {
        _vm.$set(_vm.profile.doctorData, "introduction", $$v)
      },
      expression: "profile.doctorData.introduction"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.save")))])], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("contact")))])]), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-card-content', _vm._l((_vm.profile.doctorData.contact), function(contact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('md-input-container', {
      staticClass: "col-md-5"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("contact_name")))]), _vm._v(" "), _c('md-input', {
      model: {
        value: (contact.name),
        callback: function($$v) {
          _vm.$set(contact, "name", $$v)
        },
        expression: "contact.name"
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "col-md-5"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("contact_data")))]), _vm._v(" "), _c('md-input', {
      model: {
        value: (contact.value),
        callback: function($$v) {
          _vm.$set(contact, "value", $$v)
        },
        expression: "contact.value"
      }
    })], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-warn",
      on: {
        "click": function($event) {
          _vm.deleteContact(contact)
        }
      }
    }, [_vm._v("Törlés")])], 1)
  })) : _vm._e(), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.newContact()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.add_new")))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.save")))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0892d718!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Profile.vue
// module id = 408
// module chunks = 2